import { ListSuperadminAiUsageResponseSchema } from './list-superadmin-ai-usage.schema';
/**
 * Superadmin AI Usage Endpoint Contract
 * A two-level drill-down over the per-tenant AI usage ledger: a per-tenant
 * cost/token rollup by default, or per-source × model rows when scoped to a
 * single tenant. Super-admin only.
 */ export const listSuperadminAiUsageContract = {
    method: 'GET',
    path: '/api/v2/superadmin-ai-usage',
    description: 'AI cost and token usage per tenant (super-admin only)',
    responseSchema: ListSuperadminAiUsageResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - invalid or missing token',
            403: 'Forbidden - user is not a super-admin'
        }
    }
};

//# sourceMappingURL=list-superadmin-ai-usage.contract.js.map